if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      const total = parseInt(this.dataset.cartTotal, 10) || 0;
      const minimum = parseInt(this.dataset.minimum, 10) || 0;
      const percentage = minimum > 0 ? Math.min(total / minimum, 1) : 1;
      this.style.setProperty('--free-shipping-percentage', percentage);
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}
